import { Navbar } from "../NavBar";
import classNames from "classnames";
import styles from "./Overlay.module.scss";
import { OverlayContext } from "../../context/OverlayContext";
import { useContext } from "react";
import { APPLICATION_TYPE } from '../../enums/application';
import { NavBartStartupLib } from '../NavBarStartupLib';

export const Overlay = () => {
  const { isOverlay, setOverlay } = useContext(OverlayContext);

  return (
    <div
      className={classNames(styles.overlay, {
        [styles.activeOverlay]: isOverlay,
      })}
      onClick={() => setOverlay(false)}
    >
        {process.env.REACT_APP_APPLICATION_TYPE === APPLICATION_TYPE.STARTUP_LIBRARY &&
            <NavBartStartupLib active={isOverlay}/>
        }
        {process.env.REACT_APP_APPLICATION_TYPE === APPLICATION_TYPE.DASHBOARD &&
            <Navbar active={isOverlay} />
        }

      <button
        className={classNames(styles.cross, {
          [styles.activeCross]: isOverlay,
        })}
        onClick={() => setOverlay(false)}
      >
        <img src='/assets/cross.svg' width='35' height='35' alt='cross' />
      </button>
    </div>
  );
};
